module.exports = __webpack_public_path__ + "static/img/bg-en.633ac0d6.png";